import axios from 'axios';
import toast from 'react-hot-toast';
import { getLanguage } from 'helpers/i18n';
import { getItemFromLocalStorage, removeItemFromLocalStorage } from 'helpers/localstorage';

const responseSuccessInterceptor = response => Promise.resolve(response);

const responseFailureInterceptor = ({ response = {} }) => {
  const errResponse = response?.data || null;
  (errResponse?.error || []).forEach(err => toast.error(`${err}`));
  if (errResponse?.error_code === 'INVALID_TOKEN') {
    removeItemFromLocalStorage('user');
    removeItemFromLocalStorage('org');
    removeItemFromLocalStorage('token');
    removeItemFromLocalStorage('fcm-token');
    window.location.reload();
  }
  return Promise.reject({ ...response, error: true });
};

export const getAccessToken = async () => {
  const org = getItemFromLocalStorage('org');
  return org?.token;
};

//private API config
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 10000,
  params: {},
});
instance.interceptors.request.use(
  async config => {
    try {
      config.headers.Authorization = `${await getAccessToken()}`;
      config.headers['Content-Type'] = 'application/json';
      config.headers['lang'] = `${getLanguage()}`;
    } catch (e) {
      localStorage.removeItem('user');
      window.location.reload();
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);
instance.interceptors.response.use(responseSuccessInterceptor, responseFailureInterceptor);

//public API config
export const publicApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 10000,
  params: {},
});
publicApi.interceptors.request.use(
  async config => {
    try {
      config.headers['Content-Type'] = 'application/json';
      config.headers['lang'] = `${getLanguage()}`;
    } catch (e) {
      localStorage.removeItem('user');
      window.location.reload();
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);
publicApi.interceptors.response.use(responseSuccessInterceptor, responseFailureInterceptor);

export default instance;
